// Decorative preview of the hosted checkout: the crypto options, "Pay by card"
// under them, and the "paid" result it ends in.

const MOCK_COINS = [
  "/Images/landing/coin-usdt.svg",
  "/Images/landing/coin-usdc.svg",
  "/Images/landing/coin-btc.svg",
  "/Images/landing/coin-eth.svg",
  "/Images/landing/coin-monero.svg",
];

export default function CheckoutMock() {
  return (
    <div aria-hidden="true" className="relative w-full max-w-[400px] mx-auto lg:mx-0 select-none">
      <div className="absolute inset-[-40px] rounded-full bg-[rgba(0,121,236,0.18)] blur-[90px] pointer-events-none" />
      <div className="relative rounded-[24px] border border-white/[0.09] bg-[#030b14]/90 p-6 pb-12 shadow-[0_30px_80px_rgba(0,0,0,0.55)] backdrop-blur-[17.5px]">
        <div className="text-[13px] text-white/45">Invoice #10482</div>
        <div className="mt-2 text-white text-[40px] font-medium tracking-[-0.02em]">$49.00</div>

        <div className="mt-6 mb-3 text-[13px] text-white/60">Pay with crypto</div>
        <div className="grid grid-cols-6 gap-2">
          {MOCK_COINS.map((icon) => (
            <div key={icon} className="h-12 rounded-xl border border-white/[0.07] bg-white/[0.03] flex items-center justify-center">
              <img src={icon} alt="" width={24} height={24} decoding="async" className="w-6 h-6" />
            </div>
          ))}
          <div className="h-12 rounded-xl border border-white/[0.07] bg-white/[0.03] flex items-center justify-center text-[12px] text-white/45">
            +25
          </div>
        </div>

        <div className="my-5 flex items-center gap-3 text-[12px] text-white/35">
          <span className="h-px flex-1 bg-white/10" />
          or pay with card
          <span className="h-px flex-1 bg-white/10" />
        </div>

        <div className="h-[52px] rounded-xl bg-[#0079ec] text-white font-medium flex items-center justify-center gap-2.5 shadow-[0_0_40px_rgba(0,121,236,0.35)]">
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
            <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
            <path d="M2.5 9.5h19M6.5 15h4" strokeLinecap="round" />
          </svg>
          Pay by card
        </div>

        <div className="mt-5 text-center text-[12px] text-white/35">Card payments by Stripe · US and EU</div>
      </div>

      <div className="absolute -bottom-6 -left-4 sm:-left-8 flex items-center gap-3 rounded-2xl border border-[#0079ec]/40 bg-[#04121f] px-4 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.5)]">
        <span className="w-7 h-7 rounded-full bg-[#0079ec] flex items-center justify-center">
          <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" stroke="white" strokeWidth="2">
            <path d="M3.5 8.5l3 3 6-7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <div className="leading-tight">
          <div className="text-white text-sm font-medium">Paid</div>
          <div className="text-white/45 text-[12px]">49.00 USDC received</div>
        </div>
      </div>
    </div>
  );
}
